<script setup lang="ts">
import { provide } from 'vue';
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import MarketplaceExecutionsTable from '@/modules/marketplace/components/MarketplaceExecutionsTable.vue';

provide('gridStateKey', 'MarketplaceOrders');

withDefaults(defineProps<{ filteredByCusip?: string[] }>(), {
  filteredByCusip: () => [],
});
</script>

<template>
  <div class="d-flex fill-height full-width flex-grow-1">
    <div :class="['d-flex flex-column fill-height pa-0 col']">
      <DashboardPanel no-collapse title="executions">
        <MarketplaceExecutionsTable :filtered-by-cusips="filteredByCusip" />
      </DashboardPanel>
    </div>
  </div>
</template>

<style lang="scss"></style>
